<template>
  <div class="aboutUsPage">
    <div class="header-banner-container">
      <headerCom ref="headerComDom"></headerCom>
      <div class="head-banner-content">
        <div class="head-banner-title">关于我们</div>
        <div class="head-banner-subtitle">企业员工关系管理问题的避风岗</div>
      </div>
    </div>
    <div class="main-container">
       <div class="main-content">
         <div class="main-content-title-container">
           <div class="main-content-title">公司介绍</div>
           <div class="clearboth"></div>
         </div>
         <div class="main-content-info">
           薪领航（天津）管理咨询有限公司20余年人力资源领域行业经验，通过对多领域多体制多时代各类型企业的制度制定、劳资关系处理、管理条款优化等服务，我们积累了丰富的人力服务经验。伴随政府人力政策的不断迭代更新与市场化程度的提高，为适应数字化改革，我们千锤百炼，数年实战，最终提出了“全周期员工关系管理模型”。本模型采用6维思维、多对一方式，全链路模块，云端数据等方式全面解决企业管人、用人、留人、裁人的问题。将人力资源在员工关系管理领域深入挖掘，呈体系化升级，把复杂的问题简单化，将零散的人力问题数据化。
         </div> 
        <div class="main-content-development-container">
          <img class="main-content-development-img" src="../assets/developmen_timeline.png">
          <div class="main-content-development-title">我们的发展历程</div>
          <div class="main-content-development-stage-container developmentStage1">
            <div class="main-content-development-stage-txt">我们成立了</div>
            <img class="main-content-development-stage-img" src="../assets/about us_process_icon_left.png">
            <div class="clearboth"></div>
          </div>
          <div class="main-content-development-stage-container developmentStage2">
            <div class="main-content-development-stage-txt">国企改革安置下岗职工领头羊</div>
            <img class="main-content-development-stage-img" src="../assets/about us_process_icon_right.png">
            <div class="clearboth"></div>
          </div>
          <div class="main-content-development-stage-container developmentStage3">
            <div class="main-content-development-stage-txt">专业人事外包公司以新面目运营</div>
            <img class="main-content-development-stage-img" src="../assets/about us_process_icon_left.png">
            <div class="clearboth"></div>
          </div>
          <div class="main-content-development-stage-container developmentStage4">
            <div class="main-content-development-stage-txt">提出全周期员工关系管理模型并实践提升</div>
            <img class="main-content-development-stage-img" src="../assets/about us_process_icon_right.png">
            <div class="clearboth"></div>
          </div>
          <div class="main-content-development-stage-container developmentStage5">
            <div class="main-content-development-stage-txt">开发云端SAAS软件全速推进全周期模型</div>
            <img class="main-content-development-stage-img" src="../assets/about us_process_icon_left.png">
            <div class="clearboth"></div>
          </div>
        </div>
         <div class="main-content-info">
           我们一直在打造快捷、简单、及时的处理模块，在准确性、权威性、合规性、突发性等方面逐渐加强，力求用专家团队结合数字化方式，把高端的小量的服务用数字化进行放大，让更多的企业以更低的价格享受更优质的服务。
         </div> 
       </div> 
      <div class="main-content">
         <div class="main-content-title-container">
           <div class="main-content-title">公司介绍</div>
           <div class="clearboth"></div>
         </div>
         <div class="main-introduce-container">
          <div class="main-introduce-video-container">
            <img class="main-introduce-video-play" :src="videoPlayIconSrc" v-if="!videoPlay" @click.stop="playVideo"
              @mouseenter="changeVideoIconSrc(1)" @mouseleave="changeVideoIconSrc(2)">
            <video class="main-introduce-video" :src="videoPlay?videoPlaySrc:''" poster="../assets/video_poster.png"
              webkit-playsinline="true" autoplay :controls="videoPlay" playsinline="true" muted="true" loop="loop">
              视频加载失败。
            </video>
            <div class="main-introduce-video-more-container">
              <div class="main-introduce-video-more" @click="toVideo($event)">
                查看更多视频
                <img class="main-icon-more" src="../assets/icon_more.png" />
              </div>
            </div>
          </div>
        </div>
      </div> 

    </div>


    <foot></foot>

  </div>

</template>

<script>
  import headerCom from '@/components/Header.vue';
  import foot from '@/components/Footer.vue';

  export default {
    data() {
      return {
        videoPlayIconSrc: require('../assets/icon_video_play.png'),
        videoPlaySrc: require('../assets/xlh_video1.mp4'),
        videoPlay: false, //播放视频
      }
    },
    components: {
      headerCom,
      foot
    },
    created() {
      document.title = '关于我们_薪领航管理咨询有限公司';
    },
    mounted() {
      document.addEventListener("click", (e) => {
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,0,0,x,y);
      });
    },
    methods: {
    //视频封面上播放图标，鼠标移入移除改src
     changeVideoIconSrc(key) {
        switch (key) {
          case 1:
            this.videoPlayIconSrc = require('../assets/video_page_icon_video_play.png')
            break
          case 2:
            this.videoPlayIconSrc = require('../assets/icon_video_play.png')
            break
        }
      },
      //视频播放
      playVideo() {
        this.videoPlay = true;
      },
      //跳转 视频页
      toVideo(e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.$refs.headerComDom.toVisitPage(this.$route.path,'/video',0,0,x,y);
        this.$router.push('/video');
      },
    },
  }
</script>

<style>
  .aboutUsPage .header-banner-container {
    background: url('../assets/aboutUs_heroBanner_bg_img.png');
    background-size: cover;
    padding-bottom: 29.166%;
    /*2880*840图片高宽比*/
  }

  .aboutUsPage .main-content-title {
    background: url('../assets/Line5.png') no-repeat;
    background-size: 100% 5px;
    background-position: 0% 60%;
  }

  .main-content-info {
    font-size: 16px;
    line-height: 32px;
    color: #4F617E;
    margin: auto;
    margin: 50px auto auto auto;
    width: calc(100% - 590px);
    text-align: center;
  }

  .main-content-development-container{
    margin: auto;
    width: calc(100% - 160px); 
    text-align: center;
    position: relative;
    margin: 60px auto 10px auto;
  }
  .main-content-development-img{
    width: 100%;
    height: auto;
  }
  .main-content-development-title{
    font-family: Noto Sans SC;
    font-style: normal;
    font-weight: 300;
    font-size: 32px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
  }
  .main-content-development-stage-container{
    position: absolute;
  }
  .main-content-development-stage-txt{
    font-family: Noto Sans SC;
    font-size: 16px;
    line-height: 24px;
    text-align: right;
    color: #FFFFFF;
  }
  .main-content-development-stage-img{
    float: left;
    height: 18px;
    width: auto;
  }

  .main-content-development-container .main-content-development-stage-container:nth-of-type(odd) .main-content-development-stage-txt{
     float: right;
  } 
  .main-content-development-container .main-content-development-stage-container:nth-of-type(odd) .main-content-development-stage-img{
     float: right;
     margin: 4px 14px 0 0;
  } 
  .main-content-development-stage-container:nth-of-type(odd){
    left: 62%;
  }
  .main-content-development-container .main-content-development-stage-container:nth-of-type(even) .main-content-development-stage-txt{
    float: left;
  } 
  .main-content-development-container .main-content-development-stage-container:nth-of-type(even) .main-content-development-stage-img{
    float: left;
    margin: 4px 0 0 14px;
  } 
  .main-content-development-stage-container:nth-of-type(even){
    right: 62%;
  }
  
  .main-content-development-container .main-content-development-stage-container.developmentStage1{
    top: 30.2%;
  }
  .main-content-development-container .main-content-development-stage-container.developmentStage2{
    top: 39.9%;
  }
  .main-content-development-container .main-content-development-stage-container.developmentStage3{
    top: 49.4%;
  }
  .main-content-development-container .main-content-development-stage-container.developmentStage4{
    top: 59.1%;
  }
  .main-content-development-container .main-content-development-stage-container.developmentStage5{
    top: 68.5%;
  }

</style>



// WEBPACK FOOTER //
// src/pages/aboutUs.vue